<template>
  <div v-if="isLoaded">
    <h1 class="title is-2">Kérdőív | {{ $store.state.survey.name }} </h1>
    <h5 class="title is-6 is-italic">{{ $store.state.survey.extraData }} </h5>
    <div v-if="unansweredSuddenDeathQuestions.length > 0"
         class="has-background-warning mb-2 px-3 py-2">
      <div class="is-size-4 has-text-weight-bold">
        <b-icon icon="exclamation-triangle"
                class="mr-1"/>
        Az ellenőrzést az alábbi kérdésekkel kezdje:
      </div>
      <ul>
        <li v-for="item in unansweredSuddenDeathQuestions"
            :key="`unansweredSuddenDeathQuestion_${item.question.id}`">
          <a class="sudden-death-question-link"
             @click="scrollToQuestion(item.questionBlockID, item.question.id)">
            Kérdésszám: {{ item.question.number }} ({{ item.questionBlockName }})
          </a>
        </li>
      </ul>
    </div>
    <div v-if="attentionDemandingQuestions.length > 0"
         class="has-background-danger has-text-white mb-2 px-3 py-2">
      <div class="is-size-4 has-text-weight-bold">
        A kérdőívben az alábbi figyelmet igénylő kérdések vannak:
      </div>
      <ul>
        <li v-for="(question, index) in attentionDemandingQuestions"
            :key="`attentionDemandingQuestions_${index}`">
          Kérdésszám: {{ question.number }}
        </li>
      </ul>
    </div>
    <section class="mb-6">
      <QuestionBlock v-for="questionBlock in $store.state.survey.questionBlocks"
                     :key="`questionBlock_${$route.params.survey_ID}_${questionBlock.id}`"
                     ref="questionBlocks"
                     class="mb-1"
                     :id="questionBlock.id"
                     :name="questionBlock.name"
                     :questions="questionBlock.questions"
                     :extra-question="questionBlock.extra_question ? questionBlock.extra_question : null"/>
    </section>
    <SurveyFooterMenu/>
  </div>
  <div v-else
       class="loading-container">
    <Loading :is-active="true"/>
  </div>
</template>

<script>

import QuestionBlock from '@/components/Survey/QuestionBlock'
import SurveyFooterMenu from '@/components/Survey/SurveyFooterMenu'
import Loading from '@/components/Loading'
import question from '../../components/Survey/Question.vue'

export default {
  name: 'InspectionSurvey',
  components: { SurveyFooterMenu, QuestionBlock, Loading },
  data () {
    return {
      isLoaded: false,
    }
  },
  computed: {
    question () {
      return question
    },
    attentionDemandingQuestions () {
      return this.$store.state.survey.questionBlocks
        .map(questionBlock => questionBlock.questions
          .filter(question => question.question_type === 'silent_killer_question' && question.answer === 0),
        )
        .flat()
    },
    unansweredSuddenDeathQuestions () {
      return this.$store.state.survey.questionBlocks
        .map(questionBlock => questionBlock.questions
          .filter(question => question.question_type === 'sudden_death_question' && Number(question.answer) === -1)
          .map(question => ({
            question,
            questionBlockID: questionBlock.id,
            questionBlockName: questionBlock.name,
          })),
        )
        .flat()
    },
  },
  methods: {
    // Ha a kérdés blokkja be van csukva, előbb kinyitjuk, különben nincs hová görgetni.
    async scrollToQuestion (questionBlockID, questionID) {
      const questionBlock = (this.$refs.questionBlocks || [])
        .find(block => Number(block.id) === Number(questionBlockID))
      if (questionBlock) {
        questionBlock.open()
        await this.$nextTick()
      }
      const questionElement = document.getElementById(`question_${questionID}`)
      if (questionElement) {
        questionElement.scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
    },
  },
  watch: {
    '$route.params.surveyID': {
      handler: async function () {
        this.isLoaded = false
        await this.$store.dispatch('fetchSurvey', this.$route.params.surveyID)
        this.isLoaded = true
      },
      deep: true,
      immediate: true,
    },
  },
}
</script>

<style scoped>
.loading-container {
  position: relative;
  width: 100%;
  height: 100%;
  min-width: 400px;
  min-height: 400px;
}

.sudden-death-question-link {
  color: inherit;
  text-decoration: underline;
}
</style>
